import React from "react";

export default function Web_JSON() {
  return (
    <div>
      <h1>What is JSON</h1>
      <p>
        Route: <code>/web/json</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
